var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-post-list-item control control-enabled control-area"},[_c('div',{staticClass:"view-post-list-item-title"},[_vm._v("\n\t\t"+_vm._s(_vm.post.title)+"\n\t")]),_vm._v(" "),_c('div',{staticClass:"view-post-list-item-excerpt"},[_vm._v("\n\t\t"+_vm._s(_vm.post.excerpt)+"\n\t")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ebddecc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/models/PostListItem.vue
// module id = 332
// module chunks = 0